export default {
      id: "arrow-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }